import { AbstractControl } from "@angular/forms";
import moment from "moment";

export const SuperValidators = {

    isDate: (control: AbstractControl): { [key: string]: string } | null => {
        const value = control.value
        if (String(value)?.length > 0 && control.dirty) {
            const check = moment(value, "DD/MM/YYYY").isValid()
            if (!check) {
                return { invalidDate: "La date est invalide" }
            }
            else return null;
        }
        else return null;
    },

    isHour: (control: AbstractControl): { [key: string]: string } | null => {
        const value = control.value
        if (String(value)?.length > 0 && control.dirty) {
            const check = moment(value, "HH:mm").isValid()
            if (!check) {
                return { invalidHour: "L'heure est invalide" }
            }
            else return null;
        }
        else return null;
    },

    isNumber: (control: AbstractControl): { [key: string]: string } | null => {
        const value = control.value
        if (String(value)?.length > 0 && control.dirty) {
            const check = Math.abs(+value) >= 0
            if (!check) {
                return { invalidNumber: "Le champ ne doit contenir que des chiffres" }
            }
            else return null;
        }
        else return null;
    },

    isRealName: (control: AbstractControl): { [key: string]: string } | null => {
        const value = control.value
        if (String(value)?.length > 0 && control.dirty) {
            const valid = /[`!@#$%^&*()_+\=\[\]{};:"\\|,.<>\/?~§°µ£€]|[\d]/.test(control.value);
            return valid ? { invalidCaracters: "Le champ contient des caractères invalides" } : null
        }
        else return null;
    },

    notEmpty: (control: AbstractControl): { [key: string]: string } | null => {
        const value = String(control.value).replace(/ /gi, "")
        if (value.length === 0) {
            return { invalidEmpty: "Le champ doit contenir au moins un caractère" }
        }
        return null;
    },

    isLength: (length: number) => (control: AbstractControl): { [key: string]: string } | null => {
        if (String(control.value).length !== length && control.dirty) {
            return { invalidEmpty: `Ce champ doit avoir exactement ${length} caractères` }
        }
        return null;
    },

    isPhoneNumber: (control: AbstractControl): { [key: string]: string } | null => {
        const value = control.value
        if (String(value)?.length > 0 && control.dirty) {
            const _value = String(value).replace(/ |\/|\./gi, "")
            if (String(_value).startsWith("+32") && _value.length !== 12) {
                return { invalidPhoneNumber: "Numéro de téléphone de Belgique invalide" }
            }
            else if (String(_value).startsWith("+33") && _value.length !== 13) {
                return { invalidPhoneNumber: "Numéro de téléphone de France invalide" }
            }
            return null;
        } 
        else return null;
    },

}